import { isServiceManagementMigrated } from '../../services/utils/isServiceManagementMigrated';
import { Account } from '../../accounts/models/account.model';
import { TrialState } from '../models/TrialState';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchAllSitesTrialStatesForAccount } from './fetchTrialStates';

export const createAccountTrialStatesQueryConfig = (
  accountId: string | number | undefined
) => {
  return {
    queryKey: ['trials', accountId?.toString(), 'sites states'],
    queryFn: () => fetchAllSitesTrialStatesForAccount(accountId?.toString()),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  };
};

/**
 * Returns the v2 trial states for all sites of a given account as an array of `TrialState` objects.
 * This should *not* be used to retrieve trial states for an ALP account
 */
export const useAccountTrialV2States = (
  account: Account | undefined
): UseQueryResult<Array<TrialState>> => {
  const siteIsOnServiceManagement = isServiceManagementMigrated(account);

  return useQuery({
    ...createAccountTrialStatesQueryConfig(account?.id),
    enabled: !!account && !!siteIsOnServiceManagement,
  });
};
